export default __webpack_public_path__ + "static/media/neu.032df4c9.png";